// import React, { useState } from 'react';

// import '../../App.css';
// import '../../Styles/Admin-header.css';
// import Card from '@mui/material/Card';
// import IconButton from '@mui/material/IconButton';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// // import { adminLogin } from '../../services/authService';
// import { useNavigate } from 'react-router-dom';
// // import { AdminSidebar } from './Admin-sidebar';

// function AdminHeader({ sendDataToTarget, handleComponentSelect }) {
//     const navigate = useNavigate();
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [menuCollapse, setMenuCollapse] = useState(false);
//     // const [collapseSidebar, setCollapseSidebar] = useState(false);

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };
//     const toggleFunctionality = () => {
//         // console.log("toggle");
//         setMenuCollapse((prevMenuCollapse) => !prevMenuCollapse);
//         let obj = {
//             response: 'desktop',
//             collapse: false,
//         }

//         sendDataToTarget(obj);
//     }

//     const logout = () => {
//         navigate('/Admin');
//     }

//     const changePassword = () => {
//         handleClose();
//         sessionStorage.setItem("activeLink","ChangePassword")
//         navigate('/admin-dashboard/ChangePassword');
//         handleComponentSelect('ChangePassword');
//     }
//     return (
//         <div className='row'>
//             <Card className="px-1.5 py-1 fixed top-0 z-50 w-full !rounded-none" id="m-card">
//                 <div id="173" className="grid">
//                     <div id="174" className="grid-cols-12 p-0">
//                         <div id="175" className="flex">
//                             <div id="176" className="grow flex items-center">
//                                 <div id="177" className="flex">
//                                     <div id="178" className="ps-2 flex items-center">
//                                         <button type="button" id="toggle" className={`toggleIcon ${menuCollapse ? 'open' : ''}`} onClick={toggleFunctionality} >
//                                             <span className="icon-bar bg3" id="stgl"></span>
//                                             <span className="icon-bar bg3" id="stogl"></span>
//                                             <span className="icon-bar bg3" id="stoggle"></span>
//                                         </button>
//                                     </div>
//                                     <div id="179" className="ms flex items-center">
//                                         <button type="button" id="m-toggle" className="toggleIcon">
//                                             <span className="icon-bar bg3" id="s-mtgl"></span>
//                                             <span className="icon-bar bg3" id="s-mtogl"></span>
//                                             <span className="icon-bar bg3" id="s-mtoggle"></span>
//                                         </button>
//                                     </div>
//                                     <div id="180" className="px-2 flex-items-center">
//                                         <img src="./images/cianahealth.png" id="archents-logo" className="h-3/4 w-1/4" alt='user-logo' />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div id="181" className="flex">


//                                 <div id="182" className="borderleft"></div>
//                                 <div id="183" className="px-3">
//                                     <div id="184" className="flex items-center">
//                                         <div className="" id="u-pic" style={{ cursor: 'pointer' }}>
//                                             <img src="./images/user.jpg"className='h-8 rounded-md ' id="profile" alt='user-img' />
//                                         </div>

//                                         <div id="185">
//                                             <div className="relative cursor-pointer" id="dropdown">
//                                                 <IconButton
//                                                     aria-controls="simple-menu"
//                                                     aria-haspopup="true"
//                                                     onClick={handleClick}
//                                                 >
//                                                     <ArrowDropDownIcon id="md-arrow" />
//                                                 </IconButton>
//                                             </div>
//                                             <Menu
//                                                 id="simple-menu"
//                                                 anchorEl={anchorEl}
//                                                 keepMounted
//                                                 open={Boolean(anchorEl)}
//                                                 onClose={handleClose}
//                                             >

//                                                 <MenuItem onClick={changePassword} id="changePassword">
//                                                     Change Password
//                                                 </MenuItem>
//                                                 <MenuItem onClick={logout} id="logout">
//                                                     Logout
//                                                 </MenuItem>
//                                             </Menu>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>

//             </Card>


//         </div>
//     )
// }

// export default AdminHeader;
import React, { useState, useEffect } from 'react';
import '../../App.css';
import '../../Styles/Admin-header.css';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';
import { he } from 'date-fns/locale';
import { Height } from '@material-ui/icons';

function AdminHeader({ sendDataToTarget, handleComponentSelect }) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeFlag, setActiveFlag] = useState('');
    const [userRole, setUserRole] = useState('');

    useEffect(() => {
        setUserRole(sessionStorage.getItem("role"))
        const activeLink = sessionStorage.getItem("activeLink")
        if (activeLink) {
            setActiveFlag(activeLink);
        }
    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        navigate('/Admin');
    };

    const changePassword = () => {
        handleClose();
        sessionStorage.setItem("activeLink", "ChangePassword");
        navigate('/admin-dashboard/ChangePassword');
        handleComponentSelect('ChangePassword');
    };

    return (
        <div className='row'>
            <Card className={`px-1.5 py-1 fixed top-0 z-50 w-full !rounded-none header-card ${userRole === 'ANALYTICS' ? 'header-card-full' : ''
                }`} id="m-card">
                <div id="173" className="grid">
                    <div id="174" className="grid-cols-12 p-0">
                        <div id="175" className="flex">
                            <div id="176" className="grow flex items-center">
                                <div id="177" className="flex">
                                    <div id="178" className="ps-2 flex items-center">
                                        {/* Removed menu icon and toggle button */}
                                    </div>
                                    <div id="179" className="ms flex items-center">
                                        {/* Removed extra button */}
                                    </div>
                                    <div id="180" className="px-2 flex-items-center">
                                        <img src="./images/ciana.png" id="archents-logo" className="h-10" alt='user-logo' />
                                    </div>
                                </div>
                            </div>
                            <div id="181" className="flex">
                                <div id="182" className="borderleft"></div>
                                <div id="183" className="px-3">
                                    <div id="184" className="flex items-center">
                                        <div className="" id="u-pic" style={{ cursor: 'pointer' }}>
                                            <img src="./images/user.jpg" className='h-8 rounded-md ' id="profile" alt='user-img' />
                                        </div>

                                        <div id="185">
                                            <div className="relative cursor-pointer" id="dropdown">
                                                <IconButton
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={handleClick}
                                                >
                                                    <ArrowDropDownIcon id="md-arrow" />
                                                </IconButton>
                                            </div>
                                            <Menu
                                                id="simple-menu"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleClose}
                                            >
                                                {userRole !== 'SUPERADMIN' && (
                                                    <MenuItem onClick={changePassword} id="changePassword">
                                                        Change Password
                                                    </MenuItem>
                                                )}
                                                <MenuItem onClick={logout} id="logout">
                                                    Logout
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}
export default AdminHeader;